module.exports = __webpack_public_path__ + "static/media/news-4.a46174b0.pdf";